import { useState, react, useEffect } from 'react';
import '@fontsource/roboto-condensed';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper/modules"; // Fix this import
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navbar, Nav, Container, Row, Col, Carousel, Card, Form, Button } from 'react-bootstrap';
import kinder1 from '../assets/kinder1.jpg'
import kinder2 from '../assets/kinder2.jpg'
import kinder3 from '../assets/kinder3.jpg'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/main.css'
import about from '../assets/30+.png'
import logo from '../assets/logo.jpg'
import slide4 from '../assets/slide1.jpg'
import slide2 from '../assets/slide1canva.png'
//import slide3 from '../assets/slide3.jpg'
import student from '../assets/smartclass.gif'
import teacher from '../assets/teach.gif'
import classroom from '../assets/talk.gif'
import school from '../assets/school.gif'
import support from '../assets/website.gif'
import tution from '../assets/tution.gif'
import facebook from '../assets/facebook-logo.png'
import instagram from '../assets/instagram.png'
import youtube from '../assets/Youtube_logo.png'
import whatsapp from '../assets/whatsapp.png'
import features from '../assets/features.jpg'
import artroom from '../assets/artroom.jpg'
import musicroom from '../assets/Musicroom.jpg'
import scilab from '../assets/sciencelab.jpg'
import comlab from '../assets/computerlab.jpg'
import playground from '../assets/playground.webp'
import library from '../assets/libraries.jpg'
import editicon from '../assets/edit.png'
import faqbackground from '../assets/faqbackground.png'
import slide3 from '../assets/set6.png'
import slide1 from '../assets/slie2canva.png'
import kid1 from '../assets/kid1.jpg'
import kid2 from '../assets/kid2.jpg'
import kid3 from '../assets/kid3.jpg'
import kid4 from '../assets/kid4.jpg'
import kid5 from '../assets/kid5.jpg'
import kid6 from '../assets/kid6.jpg'
import pic1 from '../assets/pic1.jpg'
import pic2 from '../assets/pic2.jpg'
import pic3 from '../assets/pic3.jpg'
import pic4 from '../assets/pic4.jpg'
import pic5 from '../assets/pic5.jpg'
import pic6 from '../assets/pic6.jpg'
import pic7 from '../assets/pic7.jpg'
import playstore from '../assets/playstore.png'
import set1 from '../assets/set2.png'








const Home = () => {
  const details = [
    {
      title: "Computer Lab",
      description: "State-of-the-art computers with high-speed internet for learning and research.",
      img: comlab,
    },
    {
      title: "Science Laboratory",
      description: "Well-equipped labs for physics, chemistry, and biology experiments.",
      img: scilab,
    },
    {
      title: "Playground",
      description: "Large playground with facilities for various sports and activities.",
      img: pic7,
    },
    {
      title: "Library",
      description: "Extensive library with books, journals, and digital resources.",
      img: library,
    },
    {
      title: "Art & Craft Room",
      description: "Space dedicated to exploring creativity and honing artistic skills.",
      img: artroom,
    },
    {
      title: "Music Room",
      description: "Fully-equipped room for learning music and instruments.",
      img: musicroom,
    },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  // State to manage the active FAQ item
  const [activeFaqIndex, setActiveFaqIndex] = useState(null);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  console.log(isDrawerOpen);
  const handleLinkClick = (link) => {
    setActiveLink(link); // Set the active link
    toggleDrawer(); // Close the drawer after selection
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    // If the same item is clicked, close it, otherwise open the clicked item
    setActiveFaqIndex(activeFaqIndex === index ? null : index);
  };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    console.log('Form Submitted:', formData);
    alert('Your enquiry has been submitted!'); // Add your own submission logic here
  };
  const isTablet = window.innerWidth > 556 && window.innerWidth <= 768;



  return (
    <>
      <body class="index-page">

        <header id="header" class="header d-flex align-items-center fixed-top py-0" style={{ backgroundColor: '#009B4A' }}>
          <style>
            {`
                    .navmenu a.active {
                        background-color: #FFD630; /* Active item background color */
                    }
                    .navmenu a:hover {
                        background-color: #F7F2E9; /* Hover item background color */
                    }
                    `}
          </style>
          <div class="container-fluid container-xl position-relative d-flex align-items-center justify-content-between " >
            <style>
              {`
                                .drawer {
                                position: fixed;
                                top: 0;
                                right: 0;
                                height: 100%;
                               
                                
                                transform: translateX(100%);
                                transition: transform 0.3s ease-in-out;
                                z-index: 3000;
                                padding: 10px;
                                }
                                .drawer.open {
                                transform: translateX(0);
                                }
                                .navmenuu ul {
                                list-style: none;
                                padding: 0;
                                margin: 0;
                                }
                                .navmenuu li {
                                margin: 10px 0;
                                }
                                .navmenuu a {
                                text-decoration: none;
                                color: #333;
                                font-size: 18px;
                                transition: color 0.3s ease;
                                }
                                .navmenuu a:hover {
                               
                                background-color:'#F7F2E9'
                                }
                                .mobile-nav-toggle {
                                font-size: 28px;
                                cursor: pointer;
                                }
                                .enquiry-button {
                                    background-color: #ffffff;
                                    color: #009B4A;
                                    border: none;
                                    
                                    border-radius: 25px;
                                    cursor: pointer;
                                    transition: background-color 0.3s ease;
                                    
                                }
                                .enquiry-button:hover {
                                    // background-color: #037d50;
                                }
                                /* Tablet */
                                @media (max-width: 991px) {
                                  .drawer{
                                  top:5%
                                    
                                    height: 50%; /* Matches tablet container height */
                                    
                                  }
                                }

                                /* Mobile */
                                @media (max-width: 576px) {
                                  .drawer {
                                    
                                    height: 50%; 
                                    
                                  }
                                }
                            `}
            </style>

            <a class="logo d-flex align-items-center">
              {/* <!-- Uncomment the line below if you also wish to use an image logo -->
                                <img src="assets/img/logo.png" alt=""> --> */}
              <img className='rounded-circle ' src={logo} alt="" style={{ height: isMobile ? '150' : '200px', width: '38px' }}></img>
              <h1 class="sitename" style={{ fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"', fontWeight: '400', color: 'white', fontSize: isMobile ? '14px' : '' }}><b>kinder valley school</b> </h1>
            </a>


            {/* Enquiry Now Button */}
            <button

              className="enquiry-button"
              onClick={() => window.location.hash = "contact"}
              style={{
                marginLeft: "auto", marginRight: isMobile ? '10px' : '20px', padding: isMobile ? '2px 2px' : '8px 15px',
                fontsize: isMobile ? '8px' : '16px',
                fontWeight: isMobile ? '400' : '600'
              }}
            >
              <img className=' ' src={editicon} alt="" style={{ height: isMobile ? '15px' : '30px', width: isMobile ? '15px' : '30px', marginRight: isMobile ? '2px' : '5px' }}></img>
              Enquiry Now
            </button>



            {/* Burger Icon */}
            <i
              className={`mobile-nav-toggle bi ${isDrawerOpen ? "bi-x" : "bi-list"
                }`}
              style={{ fontSize: isMobile ? '25px' : '50px', color: 'white' }}
              onClick={toggleDrawer}
            ></i>





            {/* Drawer */}
            <nav

              className={`navmenuu  ${isDrawerOpen ? "open" : ""}`}
              style={{
                position: "fixed",
                top: isMobile ? '10%' : "10%",
                right: "0",
                height: isMobile ? "60%" : "80%",
                width: isMobile ? "80%" : '20%',
                backgroundColor: "#f9f9f9",
                boxShadow: "-5px 0 15px rgba(0,0,0,0.2)",
                transform: isDrawerOpen ? "translateX(0)" : "translateX(100%)",
                transition: "transform 0.3s ease-in-out",
                zIndex: 3000,
                padding: isMobile ? "10px" : "30px",
                //overflowY: "auto", // Ensure the content is scrollable if it overflows
              }}

            >
              <ul style={{
                listStyle: "none", // Remove bullets
                padding: "0",
                margin: "0",
                marginTop: '20px',
                display: "flex", // Ensures items align
                flexDirection: "column", // Aligns items vertically
                gap: "0px", // Adds spacing between list items
                textAlign: "left",


              }}>
                <li ><a href="#hero"
                  className={activeLink === "home" ? "active" : ""}
                  onClick={() => handleLinkClick("home")} style={{ fontSize: isMobile ? '18px' : '24px', textAlign: 'left', fontFamily: `system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`, fontWeight: '700', color: '#04AA6D' }}><i className="fa fa-home " style={{ marginRight: '10px', color: '#FEDE3B' }}></i>Home</a></li>
                <li ><a href="#about" className={activeLink === "about" ? "active" : ""}
                  onClick={() => handleLinkClick("about")} style={{ fontSize: isMobile ? '18px' : '24px', textAlign: 'left', fontFamily: `system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`, fontWeight: '700', color: '#04AA6D' }}><i className="fa fa-info-circle" style={{ marginRight: '10px', color: '#FEDE3B' }}></i>About</a></li>
                <li ><a href="#Programmes" className={activeLink === "Programmes" ? "active" : ""}
                  onClick={() => handleLinkClick("Programmes")} style={{ fontSize: isMobile ? '18px' : '24px', textAlign: 'left', fontFamily: `system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`, fontWeight: '700', color: '#04AA6D' }}><i className="fa fa-book" style={{ marginRight: '10px', color: '#FEDE3B' }}></i>Our Programmes</a></li>
                <li ><a href="#Purpose" className={activeLink === "Purpose" ? "active" : ""}
                  onClick={() => handleLinkClick("Purpose")} style={{ fontSize: isMobile ? '18px' : '24px', textAlign: 'left', fontFamily: `system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`, fontWeight: '700', color: '#04AA6D' }}><i className="fa fa-bullseye" style={{ marginRight: '10px', color: '#FEDE3B' }}></i>Our Purpose</a></li>
                <li ><a href="#Facility" className={activeLink === "Facility" ? "active" : ""}
                  onClick={() => handleLinkClick("Facility")} style={{ fontSize: isMobile ? '18px' : '24px', textAlign: 'left', fontFamily: `system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`, fontWeight: '700', color: '#04AA6D' }}><i className="fa fa-cogs" style={{ marginRight: '10px', color: '#FEDE3B' }}></i>Our Facility</a></li>
                <li ><a href="#gallery" className={activeLink === "gallery" ? "active" : ""}
                  onClick={() => handleLinkClick("gallery")} style={{ fontSize: isMobile ? '18px' : '24px', textAlign: 'left', fontFamily: `system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`, fontWeight: '700', color: '#04AA6D' }}><i className="fa fa-images" style={{ marginRight: '10px', color: '#FEDE3B' }}></i>Our Gallery</a></li>
                <li ><a href="#team" className={activeLink === "team" ? "active" : ""}
                  onClick={() => handleLinkClick("team")} style={{ fontSize: isMobile ? '18px' : '24px', textAlign: 'left', fontFamily: `system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`, fontWeight: '700', color: '#04AA6D' }}><i className="fa fa-star" style={{ marginRight: '10px', color: '#FEDE3B' }}></i>Review</a></li>
                <li ><a href="#contact" className={activeLink === "contact" ? "active" : ""}
                  onClick={() => handleLinkClick("contact")} style={{ fontSize: isMobile ? '18px' : '24px', textAlign: 'left', fontFamily: `system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`, fontWeight: '700', color: '#04AA6D' }}><i className="fa fa-phone" style={{ marginRight: '10px', color: '#FEDE3B' }}></i>Contact</a></li>


              </ul>


            </nav>



          </div>


        </header>


        <main class="main" style={{ backgroundColor: '#009B4A' }}>
          <div
            className="marquee-container"
            style={{
              backgroundColor: '#FEDE3B', // Semi-transparent dark background
              backdropFilter: 'blur(5px)',
              width: '100%',
              //backgroundColor: 'transparent',
              position: 'fixed', // Fixes the position
              top: isMobile ? '45px' : '70px', // Adjust based on header height
              zIndex: 99,
              paddingTop: isMobile ? '2%' : '0.5%',
              //marginBottom: '10px',

            }}
          >
            <marquee behavior={isMobile ? "scroll" : "alternate"} direction="left" style={{ color: 'black', Text: 'bold', fontSize: isMobile ? '12px' : '16px' }}>
              Free Admission is going on - (Kinder Valley School Tamulia!)  +91 81024 21400
            </marquee>
          </div>


          {/* <!-- Hero Section --> */}
          {/* <!-- Hero Section --> */}
          <section id="hero" className="hero section" style={{}}>
            <style>
              {`
      /* Default (desktop/laptop) */
      #hero-carousel img {
        width: 100%; /* Full width */
        height: 630px; /* Matches carousel container */
        object-fit: cover; /* Ensure proper cropping */
      }

      /* Tablet */
      @media (max-width: 991px) {
        #hero-carousel img {
          width: 100%;
          height: 500px; /* Matches tablet container height */
          object-fit: contain;
        }
      }

      /* Mobile */
      @media (max-width: 576px) {
        #hero-carousel img {
          width: 100%;
          height: 350px; /* Matches mobile container height */
          object-fit: contain;
        }
      }
    `}
            </style>
            <div
              id="hero-carousel"
              data-bs-interval="3000"
              className="container-fluid carousel carousel-fade p-0"
              data-bs-ride="carousel"
              data-bs-pause="false"
              style={{ backgroundColor: '#009B4A' }}
            >
              {/* <!-- Slide 1 --> */}
              <div className="carousel-item active w-full m-0 p-0">
                <div className="carousel-container d-flex justify-content-center align-items-center" style={{
                  // Fixed height for the slide container
                  width: '100%',   // Full width for responsiveness
                }}>
                  <img
                    src={slide1}
                    alt="Slide 1"
                    style={{
                      // width: '100%',            // Ensures the image spans the full width of the container
                      // height: '400px',           // Maintains the aspect ratio
                      // objectFit: 'cover',       // Ensures the image covers its container
                      // margin: '5%'
                    }}
                  />
                </div>
              </div>

              {/* <!-- Slide 2 --> */}
              <div className="carousel-item">
                <div className="carousel-container d-flex justify-content-center align-items-center" style={{
                  // Fixed height for the slide container
                  width: '100%',   // Full width for responsiveness
                }}>
                  <img
                    src={set1}
                    alt="Slide 2"
                    style={{
                      // width: '100%',
                      // height: '400px',
                      // objectFit: 'cover',
                    }}
                  />
                </div>
              </div>

              {/* <!-- Slide 3 --> */}
              <div className="carousel-item" >
                <div className="carousel-container d-flex justify-content-center align-items-center" style={{
                  // Fixed height for the slide container
                  width: '100%',   // Full width for responsiveness
                }}>
                  <img
                    src={slide3}
                    alt="Slide 3"
                    style={{
                      // width: '100%',
                      // height: '400px',
                      // objectFit: 'cover',
                    }}
                  />
                </div>
              </div>
              {/* Custom navigation icons */}
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#hero-carousel"
                data-bs-slide="prev"
                style={{
                  background: 'none', // Remove default background
                  border: 'none', // Remove border
                  fontSize: '6rem', // Increase size
                  color: '#ffffff', // White color for visibility
                  zIndex: 1, // Ensure visibility above carousel
                }}
              >
                &#8249; {/* Left angle bracket (<) */}
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#hero-carousel"
                data-bs-slide="next"
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '6rem',
                  color: '#ffffff',
                  zIndex: 1,
                }}
              >
                &#8250; {/* Right angle bracket (>) */}
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </section>

          {/* <!-- /Hero Section -->

          <!-- About Section --> */}



          <section id="about" class="about section" style={{ backgroundColor: '#F7F2E9' }}>

            <div class="container">

              <div class="row position-relative">

                <div class="col-lg-7 about-img" data-aos="zoom-out" data-aos-delay="200">

                  <img src={about} /></div>

                <div class="col-lg-7" data-aos="fade-up" data-aos-delay="100">
                  <div className="d-flex align-items-center" style={{ gap: '0px' }}>
                    <style>
                      {`
                        @keyframes bounce {
                          0%, 100% {
                            transform: translateY(0);
                          }
                          50% {
                            transform: translateY(-10px);
                          }
                        }
                        .logo-bounce {
                          animation: bounce 3s infinite;


                        }
                        `
                      }
                    </style>
                    {/* <img
                      className="rounded-circle m-2  logo-bounce"
                      src={logo}
                      alt="QURAISHA ENGLISH SCHOOL Logo"
                      style={{ height: '90px', width: '85px' }}
                    /> */}
                    <h2 className="inner-title m-2  " style={{ fontFamily: 'Roboto Condensed, sans-serif', fontWeight: '700', color: '#009B4A' }}>Kinder Valley School</h2>
                  </div>
                  <div class="our-story" style={{ backgroundColor: '#F7F2E9' }}>
                    {/* <h4>Est 1988</h4> */}
                    <div class="container section-title m-0 p-0 " >
                      <h2 style={{ fontFamily: 'Roboto Condensed, sans-serif', color: 'black' }}>Education</h2>
                    </div>
                    {/* <h3 className=''>Our Story</h3> */}
                    <p>
                      Established with a vision to inspire young minds and foster a love for learning, Kinder Valley School is committed to providing a nurturing and stimulating environment for children. Since its inception, our school has been dedicated to laying a strong foundation for academic, social, and emotional growth.
                      At Kinder Valley School, we emphasize:
                    </p>
                    <ul>
                      <li><i class="bi bi-check-circle"></i> <span>A creative and engaging curriculum tailored for early learning excellence.</span></li>
                      <li><i class="bi bi-check-circle"></i> <span>A focus on values, empathy, and character building from a young age.</span></li>
                      <li><i class="bi bi-check-circle"></i> <span>Encouraging curiosity, innovation, and independent thinking in every child.</span></li>
                    </ul>
                    <p>
                      Our experienced educators, modern facilities, and child-centric approach ensure that every learner feels supported and inspired. Join us on this wonderful journey to spark a lifelong passion for learning and shape the bright futures of tomorrow.







                    </p>

                    <div class="watch-video d-flex align-items-center position-relative">
                      <i class="bi bi-play-circle"></i>
                      <a href="" class="glightbox stretched-link"> Watch Our Journey</a>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </section>
          {/* <!-- /About Section -->

          <!-- Clients Section --> */}
          {/* <section id="clients" class="clients section light-background">

            

          </section> */}

          {/* <!-- Pricing Section --> */}
          <section id="Programmes" class="pricing section" style={{ backgroundColor: '#009B4A' }}>

            {/* <!-- Section Title --> */}
            <div class="container section-title" data-aos="fade-up" style={{}}>
              <h2 style={{ color: 'white', fontFamily: 'Roboto Condensed, sans-serif', fontWeight: '800' }}>Our <span style={{ color: '#FEDE3B' }}>Programmes</span></h2>
              {/* <p>Explore the facilities we offer to ensure a well-rounded education for students.</p> */}
              {/* <h3 style={{ fontFamily: 'sans-serif' }}>DISCOVER THE FACILITIES THAT SHAPE SUCCESS</h3> */}
            </div>


            <div class="container p-2 " data-aos="zoom-in" data-aos-delay="100" style={{ maxwidth: '1000px', width: '100%' }}>


              <Swiper
                modules={[Pagination, Scrollbar, Autoplay]}
                spaceBetween={30}
                slidesPerView={1}

                pagination={{ clickable: true }}
                autoplay={{ delay: 3000, disableOnInteraction: false }}

                breakpoints={{
                  768: { slidesPerView: 2 }, // Show 2 cards on tablets
                  1024: { slidesPerView: 3 }, // Show 3 cards on larger screens
                }}
              >
                {details.map((detail, index) => (
                  <SwiperSlide key={index}>
                    <div className="card pricing-item p-0" style={{ border: "1px solid #ddd", borderRadius: "8px", overflow: "hidden", backgroundColor: 'white' }}>
                      <img
                        src={detail.img}
                        alt={detail.title}
                        style={{ width: "100%", height: "300px", objectFit: "cover" }}
                      />
                      <div className="card-body" style={{ padding: "16px" }}>
                        <h3 style={{ fontSize: "1.5rem", marginBottom: "8px", fontWeight: '700' }}>{detail.title}</h3>
                        {/* <p style={{ fontSize: "1rem", color: "#666" }}>{detail.description}</p> */}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

            </div>

          </section>

          {/* <!-- Features 2 Section --> */}
          <section id="Purpose" class="features section features-2" style={{ backgroundColor: '#F7F2E9' }}>

            {/* <!-- Section Title --> */}
            {/* <div class="container section-title" data-aos="fade-up">
              
              <div class="text-left m-0 mt-3" data-aos="fade-up" data-aos-delay="100">
                
              </div>


            </div> */}

            <div class="container">

              <div class="row gy-4 justify-content-between">
                <div class="features-image col-lg-4 d-flex align-items-center" data-aos="fade-up" style={{}}>





                  <img src={kid1} class="img-fluid m-0 p-0 " alt="" style={{ border: '2px solid #009B4A', borderRadius: '15px' }} />
                </div>
                <div class="col-lg-7 d-flex flex-column justify-content-center section-title">
                  <h2 className='m-4' style={{ color: 'black', fontFamily: 'Roboto Condensed, sans-serif', fontWeight: '800' }}>Our <span style={{ color: '#009B4A' }}>Purpose</span></h2>

                  <div class="features-item d-flex p-4" data-aos="fade-up" data-aos-delay="200">
                    <i class="bi bi-mortarboard flex-shrink-0"></i>
                    <div>
                      <h4>Why education is important? </h4>
                      <p style={{ fontFamily: 'Roboto Condensed, sans-serif', fontWeight: '500', fontSize: '18px' }}>“Education is the passport to the future for to those who prepare for it today". The beautiful thing about learning is that no one can take it away from you. It is the most powerful weapon you can use to change the world. So, you don't have to be great to start it but you
                        have to start to be great. So, education is as important as food to be the proper oneself the God has made.
                      </p>
                    </div>
                  </div>{/* <!-- End Features Item--> */}



                </div>
              </div>

            </div>

          </section>

          {/* <!-- Services Section --> */}
          <section id="Facility" class="services section" style={{ backgroundColor: '#F7F2E9' }}>

            {/* <!-- Section Title --> */}
            <div class="container section-title" data-aos="fade-up">
              <h2 style={{ color: 'black', fontFamily: 'Roboto Condensed, sans-serif', fontWeight: '800' }}>Our <span style={{ color: '#009B4A' }}>Facility</span></h2>
              {/* <h4>WHY US?</h4> */}
            </div>{/* <!-- End Section Title --> */}

            <div class="container">

              <div class="row gy-2 ">

                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <img
                        src={teacher}
                        className="img-fluid"
                        alt="20+ Activities"
                        style={{ maxWidth: '80%', height: 'auto' }}
                      />
                    </div>
                    <a class="stretched-link">
                      <h3>Friendly Teachers, Fun Learning</h3>
                    </a>
                    <p>We provide friendly teachers which creator fun learning for your gems.</p>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <img
                        src={classroom}
                        className="img-fluid"
                        alt="20+ Activities"
                        style={{ maxWidth: '80%', height: 'auto' }}
                      />
                    </div>
                    <a class="stretched-link">
                      <h3>Building Confidence Through Exciting Events</h3>
                    </a>
                    <p>For building confidences and develope the overall personalities we events organize various events like annual function, annual sports children days, summer camp, picnic, food fest etc.</p>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <img
                        src={support}
                        className="img-fluid"
                        alt="20+ Activities"
                        style={{ maxWidth: '80%', height: 'auto' }}
                      />
                    </div>
                    <a class="stretched-link">
                      <h3>Smart Management with Our App</h3>
                    </a>
                    <p>We also maintain our online application to
                      keep on check for each and every works that are
                      done in the campus.
                    </p>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
                  <div class="service-item position-relative ">
                    <div class="icon">
                      <img
                        src={school}
                        className="img-fluid"
                        alt="20+ Activities"
                        style={{ maxWidth: '80%', height: 'auto' }}
                      />
                    </div>
                    <a class="stretched-link">
                      <h3>Aiming for ICSF Affiliation</h3>
                    </a>
                    <p>We are aimed towards getting the affiliation from the ICSF pattern of education.</p>
                    <a class="stretched-link"></a>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <img
                        src={tution}
                        className="img-fluid"
                        alt="20+ Activities"
                        style={{ maxWidth: '80%', height: 'auto' }}
                      />
                    </div>
                    <a class="stretched-link">
                      <h3>No Tuition Required</h3>
                    </a>
                    <p>No extra tuition classes required for our  students.</p>
                    <a class="stretched-link"></a>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="600">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <img
                        src={student}
                        className="img-fluid"
                        alt="20+ Activities"
                        style={{ maxWidth: '80%', height: 'auto' }}
                      />
                    </div>
                    <a class="stretched-link">
                      <h3>CCTV, Digital Classrooms, Transport</h3>
                    </a>
                    <p>We provide CCTV surveillance, digital classroom,
                      transport facilities etc.
                    </p>
                    <a class="stretched-link"></a>
                  </div>
                </div>

              </div>

            </div>

          </section>

          {/* <!-- Call To Action Section --> */}
          {/* <section id="call-to-action" class="call-to-action section dark-background" style={{backgroundColor:'#009B4A'}}>

            <img src="./assets/img/cta-bg.jpg" alt="" />

            <div class="container">
              <div class="row justify-content-center" data-aos="zoom-in" data-aos-delay="100">
                <div class="col-xl-10">
                  <div class="text-center">
                    <h3>Our Director</h3>
                    <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                    <a class="cta-btn" href="#">Call To Action </a>
                  </div>
                </div>
              </div>
            </div>

          </section> */}



          {/* <!-- Gallery Section --> */}
          <section id="gallery" class="gallery section mt-0" style={{ backgroundColor: '#009B4A' }}>
            <style>{
              `.gallery .gallery-item {
                  position: relative;
                  overflow: hidden;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }

                .gallery .gallery-img {
                  width: 400px; /* Ensures the image fits the width of its container */
                  height: 200px; /* Set a fixed height for all images */
                  object-fit: cover; /* Ensures the image maintains aspect ratio and covers the container */
                  transition: transform 0.3s ease, box-shadow 0.3s ease;
                }

                .gallery .gallery-img:hover {
                  transform: scale(1.1); /* Slight zoom effect on hover */
                  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3); /* Add shadow on hover */
                }

                .gallery .row.g-0 {
                  margin: 0px;
                }`

            }</style>

            {/* <!-- Section Title --> */}
            <div class="container section-title" data-aos="fade-up">
              <h2 style={{ color: 'white', fontFamily: 'Roboto Condensed, sans-serif', fontWeight: '800' }}>Our <span style={{ color: '#FEDE3B' }}>Gallery</span></h2>
              {/* <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p> */}
              {/* <h3 style={{ fontFamily: 'sans-serif' }}>EXPLORE MOMENTS THAT DEFINE US</h3> */}
            </div>{/* <!-- End Section Title --> */}

            <div class="container-fluid " data-aos="fade-up" data-aos-delay="100">

              <div class="row g-0 p-4 m-4 mt-0">

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a className="glightbox" data-gallery="images-gallery">
                      <img src={pic1} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={pic2} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={pic4} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={pic3} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={kid1} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={kid2} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={kid3} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={kid4} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a className="glightbox" data-gallery="images-gallery">
                      <img src={kid5} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={kid6} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={pic7} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4">
                  <div class="gallery-item">
                    <a class="glightbox" data-gallery="images-gallery">
                      <img src={pic6} alt="" class="img-fluid gallery-img" />
                    </a>
                  </div>
                </div>


              </div>

            </div>

          </section>



          <section id="team" class="team section" style={{ backgroundColor: '#F7F2E9' }}>


            <div class="container section-title" data-aos="fade-up">
              <h2 style={{ color: 'black', fontFamily: 'Roboto Condensed, sans-serif', fontWeight: '800' }}>Our  Parents Are Our<span style={{ color: '#009B4A' }}> True Ambassadors!</span></h2>
              {/* <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p> */}
            </div>{/* <!-- End Section Title --> */}

            <div class="container">

              <div class="row">

                <div class="col-lg-4 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="100">
                  <div class="member">
                    <img src="./assets/img/team/team-1.jpg" class="img-fluid" alt="" />
                    <div class="member-content" style={{ borderColor: '#FEDE3B' }}>
                      <h4>John Smith</h4>
                      <span>Father of Grade 5 Student</span>
                      <p>
                        "The school has been an incredible partner in my child’s education. The teachers are so caring, and the learning environment is outstanding."
                      </p>

                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="200">
                  <div class="member">
                    <img src="./assets/img/team/team-2.jpg" class="img-fluid" alt="" />
                    <div class="member-content">
                      <h4>Maria Johnson</h4>
                      <span>Mother of Grade 8 Student</span>
                      <p>
                        "I’m so impressed with the holistic approach this school takes. My child has grown academically and personally since joining."
                      </p>

                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="300">
                  <div class="member">
                    <img src="./assets/img/team/team-3.jpg" class="img-fluid" alt="" />
                    <div class="member-content">
                      <h4>David Williams</h4>
                      <span>Father of Grade 10 Student</span>
                      <p>
                        "The staff truly care about the students. My child feels safe, supported, and motivated to succeed."
                      </p>

                    </div>
                  </div>
                </div>

              </div>

            </div>

          </section>

          {/* <!-- Faq Section --> */}
          <section id="faq" class="faq section"
            style={{
              backgroundImage: `url(${faqbackground})`, // Use url() to reference the image
              backgroundSize: 'cover',                 // Ensures the image covers the slide
              backgroundPosition: 'center',            // Centers the image

            }}>

            {/* <!-- Section Title --> */}
            <div class="container section-title" data-aos="fade-up">
              <h2 style={{ color: 'black', fontFamily: 'Roboto Condensed, sans-serif', fontWeight: '800' }}>Frequently <span style={{ color: '#009B4A' }}>Asked Questions</span></h2>
              {/* <h3 style={{ fontFamily: 'sans-serif' }}>COMMON QUESTIONS ANSWERED</h3> */}
            </div>{/* <!-- End Section Title --> */}

            <div class="container">

              <div class="row justify-content-center">

                <div class="col-lg-10" data-aos="fade-up" data-aos-delay="100">

                  <div class="faq-container rounded-4 p-4" style={{ backgroundColor: 'white', border: '2px solid #FEDE3B' }}>

                    <div class={`faq-item ${activeFaqIndex === 0 ? 'faq-active' : ''}`} onClick={() => toggleFaq(0)}>
                      {/* <i className="faq-icon bi bi-question-circle"></i> */}
                      <h3>What is the admission process?</h3>
                      <div class="faq-content">
                        <p>The admission process involves submitting an application form, required documents, and completing an entrance assessment if applicable.</p>
                      </div>
                      <i class="faq-toggle bi bi-chevron-right"></i>
                    </div>
                    {/* <i className="faq-toggle bi bi-chevron-right"></i> */}

                    <div class={`faq-item ${activeFaqIndex === 1 ? 'faq-active' : ''}`} onClick={() => toggleFaq(1)}>
                      <h3>What facilities does the school offer?</h3>
                      <div class="faq-content">
                        <p>Our school provides a library, computer labs, science laboratories, sports facilities, and extracurricular activity programs.</p>
                      </div>
                      <i class="faq-toggle bi bi-chevron-right"></i>
                    </div>

                    <div class={`faq-item ${activeFaqIndex === 2 ? 'faq-active' : ''}`} onClick={() => toggleFaq(2)}>
                      <h3>What is the school’s fee structure?</h3>
                      <div class="faq-content">
                        <p>The fee structure varies based on the class level. Please contact the admissions office for detailed information.</p>
                      </div>
                      <i class="faq-toggle bi bi-chevron-right"></i>
                    </div>

                    <div class={`faq-item ${activeFaqIndex === 3 ? 'faq-active' : ''}`} onClick={() => toggleFaq(3)}>
                      <h3>What safety measures are in place?</h3>
                      <div class="faq-content">
                        <p>We ensure safety with 24/7 CCTV monitoring, trained staff, and regular safety drills.</p>
                      </div>
                      <i class="faq-toggle bi bi-chevron-right"></i>
                    </div>



                  </div>

                </div>

              </div>

            </div>

          </section>



          {/* <!-- Contact Section --> */}
          <section id="contact" class="contact section" style={{ backgroundColor: '#F7F2E9' }}>

            {/* <!-- Section Title --> */}
            <div class="container section-title" data-aos="fade-up">
              <h2 style={{ color: 'black', fontFamily: 'Roboto Condensed, sans-serif', fontWeight: '800' }}>Admission <span style={{ color: '#009B4A' }}>Enquiry</span></h2>
              {/* <h3 style={{ fontFamily: 'sans-serif' }}>LET'S CONNECT!</h3> */}
            </div>{/* <!-- End Section Title --> */}

            <div class="container" data-aos="fade" data-aos-delay="100">

              <div class="row gy-4">

                <div class="col-lg-5">
                  <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
                    {/* <i class="bi bi-geo-alt flex-shrink-0"></i> */}
                    <div>
                      {/* <h3>Address</h3> */}
                      <p style={{ fontSize: '18px' }}>The first 10 years Of life of a child is an important time for attaining academic & social skills. This is the stage where one should give special attention, to mould one's nature.

                        We try to Provide our children the creative environment to learn about God, to make friends and to practice readiness skill. They will be gain an over all education and achieve their potential in all field with play ang Joyful creativity. Our school is scaling new
                        heights with excellent and reputed professionals training our children in a range of co-curricular activities. We provide the environment where they can build their overall development. Most importantly, our aim is to make education a fun-filled enjoyable learning and growing experience on the solid foundation of values and we want our children to have fond memories of their time spent with us, long after they have left the portals of the school.
                      </p>
                    </div>



                  </div>
                  {/* <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="200">



                    <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
                      <i class="bi bi-telephone flex-shrink-0"></i>
                      <div>
                        <h3>Call Us</h3>
                        <p>+1 5589 55488 55</p>
                      </div>
                    </div>



                  </div>
                  <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="200">


                    <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
                      <i class="bi bi-envelope flex-shrink-0"></i>
                      <div>
                        <h3>Email Us</h3>
                        <p>info@example.com</p>
                      </div>
                    </div>

                  </div> */}



                </div>
                <div class="col-lg-7">
                  <form
                    onSubmit={handleSubmit}
                    className="php-email-form"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <div
                      className="row gy-4 p-4 rounded-4"
                      style={{
                        backgroundColor: 'white',
                        border: '2px solid #FEDE3B',
                      }}
                    >
                      <div className="col-md-6">
                        <input
                          type="text"
                          name="name"
                          className="form-control rounded"
                          placeholder="Your Name"
                          required
                          style={{ border: '2px solid #C7C5C5' }}
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <input
                          type="email"
                          name="email"
                          className="form-control rounded"
                          placeholder="Your Email"
                          required
                          style={{ border: '2px solid #C7C5C5' }}
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-12">
                        <input
                          type="text"
                          name="subject"
                          className="form-control rounded"
                          placeholder="Subject"
                          required
                          style={{ border: '2px solid #C7C5C5' }}
                          value={formData.subject}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-12">
                        <textarea
                          name="message"
                          rows="6"
                          className="form-control rounded"
                          placeholder="Message"
                          required
                          style={{ border: '2px solid #C7C5C5' }}
                          value={formData.message}
                          onChange={handleChange}
                        ></textarea>
                      </div>

                      <div className="col-md-12 text-center">
                        <button type="submit" style={{ padding: '10px 20px', backgroundColor: '#009B4A', color: 'white', border: 'none', borderRadius: '5px' }}>
                          Enquiry Now
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

              </div>
            </div>

          </section>

        </main>

        <footer id="footer" class="footer light-background" style={{ backgroundColor: '#009B4A' }}>

          <div className="container footer-top">
            <div className="row gy-4">
              <div className="col-lg-5 col-md-6 footer-about text-align-left" style={{ textAlign: 'left', color: '#FEDE3B' }}>
                <h3 class="sitename" style={{ color: 'white' }}>KINDER VALLEY SCHOOL</h3>
                <p><h5 style={{ color: "black" }}>Address:</h5> Noor Colony,Near Mallick Garden, TOP Road, Tamuliya,Kharsawan <br></br>Jharkhand 831012 </p>
                <h6 style={{ color: "black" }}>Contact number: <span style={{ color: "#FEDE3B" }}>8651163082</span></h6>


                <h6 style={{ color: "black" }}>Call number: <span style={{ color: "#FEDE3B" }}>8651163082</span></h6>

                <h6 style={{ color: "black" }}>WhatsApp: <span style={{ color: "#FEDE3B" }}>+91 8102421400</span></h6>

              </div>
              <div className="col-lg-4 col-md-6 footer-newsletter ">
                <h4 style={{ color: 'white' }}>Our Location</h4>
                {/* Google Map Embed */}
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3676.668966912751!2d86.19805889999999!3d22.8517337!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f5e3ddaaaaaaab%3A0x31d585d006d9879e!2sKinder%20valley%20school!5e0!3m2!1sen!2sin!4v1737293269223!5m2!1sen!2sin" width="300" height="200" style={{ border: "0px" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


              </div>

              <div className="col-lg-3 col-md-12 footer-links ">
                <h4 style={{ color: 'white' }}>Connect Us</h4>
                <a href="https://wa.me/918102421400" target="_blank" rel="noopener noreferrer" className="btn p-0 m-2" >
                  <img src={whatsapp} className="m-0" style={{ height: isMobile ? '25px' : '35px', width: 'auto', padding: '0px', }}></img>
                </a>
                <a href="https://www.facebook.com/KVSjamshedpur/" target="_blank" rel="noopener noreferrer" className="btn m-0 p-0 m-2">
                  <img src={facebook} className="m-0" style={{ height: isMobile ? '25px' : '40px', width: 'auto', padding: '0px' }}></img>
                </a>
                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="btn  p-0 m-0 m-2">
                  <img src={instagram} className="m-0" style={{ height: isMobile ? '25px' : '40px', width: 'auto', padding: '0px' }}></img>
                </a>
                <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="btn p-0 m-0 m-2">
                  <img src={youtube} className="m-0" style={{ height: isMobile ? '20px' : '30px', width: isMobile ? '30px' : '50px', padding: '0px' }}></img>
                </a>
                <br></br>

                <img
                  src={playstore}  // Replace this with your image URL
                  alt="Our App"
                  style={{
                    width: '130px',  // Adjust the size of the image as needed
                    cursor: 'pointer',  // Makes the image look clickable
                    borderRadius: '5px',
                    left: '0px',
                    marginBottom: '5px'
                  }}
                />
              </div>





            </div>
          </div>

          <div className="container copyright text-center mt-4">
            <p className='m-0 p-0'>© <span>Copyright</span> <strong className="px-1 sitename">TheVectorX</strong> <span>All Rights Reserved</span></p>
            <div className="credits m-0 p-0">
              Designed by <a href="">TheVectorX</a>
            </div>
          </div>
        </footer>

        {/* <!-- Scroll Top --> */}
        <a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

        {/* <!-- Preloader --> */}
        {/* <div id="preloader"></div> */}

        {/* <!-- Vendor JS Files --> */}
        <script src="./assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
        <script src="./assets/vendor/php-email-form/validate.js"></script>
        <script src="./assets/vendor/aos/aos.js"></script>
        <script src="./assets/vendor/glightbox/js/glightbox.min.js"></script>
        <script src="./assets/vendor/swiper/swiper-bundle.min.js"></script>

        {/* <!-- Main JS File --> */}
        <script src="./assets/js/main.js"></script>

      </body >
    </>
  );
};

export default Home;
